import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=6a248d68&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=6a248d68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a248d68",
  null
  
)

export default component.exports